import { api } from "./client";

export interface UserBrief {
  id: number;
  name: string;
  role: string;
  is_active: boolean;
  is_field_worker: boolean;
  color: string | null;
}

export interface UserPreferences {
  nav_order?: string[];
  [key: string]: unknown;
}

export const usersApi = {
  list: () => api.get<UserBrief[]>('/users/'),
};

export const preferencesApi = {
  get:              ()                       => api.get<UserPreferences>('/users/me/preferences'),
  save:             (prefs: UserPreferences) => api.put<UserPreferences>('/users/me/preferences', prefs),
  getCompanyDefault: ()                      => api.get<UserPreferences>('/users/company-nav-order'),
};
